import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-mdo',
  templateUrl: './mdo.component.html',
  styleUrls: ['./mdo.component.scss']
})
export class MdoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

